import React, { useEffect, useState } from "react";
import {
  handleStartDate,
  handleStartDateCommon,
} from "../../../../utils/helper";
import { deleteCalls, getCallRecord } from "../../AxiosRtk/CallSms";
import moment from "moment";
// import Swal from "sweetalert2";
import { setShowMessage } from "../../AxiosRtk/successMessage";
import { useDispatch } from "react-redux";
import useLangTranslation from "../../../customHooks/languageProvider";
import Select from "react-select";
import useDurationOption from "../../../customHooks/durationOption";
import DateFilter from "../../../shared/DateFilter/DateFilter";

const CallLog = ({ deviceId, selectedKidId }) => {
  const dispatch = useDispatch();
  const { durationOptionsFunction } = useDurationOption();
  const durationOptions = durationOptionsFunction();
  const [selectedDuration, setSelectedDuration] = useState(1);
  const initalStartDate = moment().locale("en").format("YYYY-MM-DD HH:mm:ss");
  const [startDate, setStartDate] = useState(initalStartDate);
  const initialEndDate = moment().locale("en").format("YYYY-MM-DD HH:mm:ss");
  const [endDate, setEndDate] = useState(initialEndDate);
  const [callLogs, setCallLogs] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const { getLangTranslation } = useLangTranslation();

  const handleCheckboxClick = (id) => {
    if (selectedItems.includes(id)) {
      setSelectedItems(selectedItems.filter((itemId) => itemId !== id));
    } else {
      setSelectedItems([...selectedItems, id]);
    }
  };
  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedItems([]);
    } else {
      setSelectedItems(callLogs.map((item) => item.ID));
    }
    setSelectAll(!selectAll);
  };
  function getCalls() {
    const obj = {
      startDate: startDate,
      endDate: endDate,
      activityType: "CALL_LOGS",
      kidId: selectedKidId,
      deviceId: deviceId,
    };
    getCallRecord(obj)
      .then((res) => {
        setCallLogs(res?.data?.result);
      })
      .catch((err) => {
        console.log("rating catch error ==>>", err?.response?.data?.message);
      });
  }
  useEffect(() => {
    if (deviceId) {
      getCalls();
    }
  }, [deviceId, startDate]);
  // const handleDelete = async () => {
  //   const payload = {
  //     id: selectedItems,
  //     activityType: "CALL_LOGS",
  //     isAlertDelete: 0,
  //     isDeleteAll: 1,
  //   };
    
  //   try {
  //     const { data } = await deleteCalls(payload);
  //     if (data) {
  //       // Show success message
  //       dispatch(
  //         setShowMessage({
  //           showMessage: true,
  //           defaultMessage: data?.message,
  //           message: data?.message,
  //         })
  //       );
  
  //       // Clear selected items and refetch the call logs
  //       setSelectedItems([]);
  //       getCalls(); // Refresh the call logs after deletion
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };


  const handleDelete = async () => {
    let payload;

    if (selectAll) {
      payload = {
        id: 0, // Assuming '0' means delete all
        activityType: "CALL_LOGS",
        isAlertDelete: 0,
        isDeleteAll: 1, // Indicating that we want to delete all
        deviceId: deviceId,
      };
    } else {
      let deleteId;

      // If there is only one selected item, convert it to a string
      if (selectedItems.length === 1) {
        deleteId = selectedItems[0].toString();
      } else {
        deleteId = selectedItems;
      }

      payload = {
        id: deleteId, // For multiple selected items
        activityType: "CALL_LOGS",
        isAlertDelete: 0,
        isDeleteAll: 0, // Indicating it's not a 'delete all' action
        deviceId: deviceId,
      };
    }

    try {
      const { data } = await deleteCalls(payload);
      if (data) {
        dispatch(
          setShowMessage({
            showMessage: true,
            defaultMessage: data?.message,
            message: data?.message,
          })
        );
        // closeDeletedSelected();
        setSelectedItems([]);
        setSelectAll(false);


        // Delay the call to getCalls by 12 seconds
        setTimeout(() => {
          // window.location.reload();

          getCalls(); // Fetch the updated SMS logs after 12 seconds
        }, 3000);
      }
    } catch (error) {
      // closeDeletedSelected();
      console.log("Error deleting SMS logs:", error);
    };
  };
  
  return (
    <>
      <div className="d-flex align-items-center justify-content-between flex-wrap gap-6 mb-6">
        <div className="d-flex align-items-center flex-wrap gap-6">
          <div className="form-check">
            <input
              className="form-check-input"
              id="enableScreenshot"
              type="checkbox"
              role="switch"
              checked={selectAll}
              onChange={handleSelectAll}
            />
            <label className="form-check-label text-dark" htmlFor="selectAll">
              {getLangTranslation(
                "MANAGE_NOTIFICATION_SELECT_ALL",
                "Select All"
              )}
            </label>
          </div>
          <button
            className="btn btn-outline-primary"
            type="button"
            onClick={handleDelete}
          >
            {getLangTranslation(
              "SCREENSHOT_HISTORY_BUTTON_DELETE_SELECTED",
              "Delete selected"
            )}
          </button>
        </div>
        <div className="d-flex align-items-center gap-3 justify-content-end flex-fill">
          <DateFilter
            startDate={startDate}
            endDate={endDate}
            setEndDate={setEndDate}
            setStartDate={setStartDate}
            selectedDuration={selectedDuration}
          />
          <Select
            className="custom-select col-lg-4"
            classNamePrefix="custom-select"
            placeholder="Select"
            onChange={(val) => {
              handleStartDateCommon(
                val,
                setStartDate,
                setSelectedDuration,
                setEndDate
              );
            }}
            options={durationOptions}
            value={
              durationOptions?.find(
                (item) => item?.value === selectedDuration
              ) || ""
            }
          />
        </div>
      </div>
      <div className="table-responsive">
        <table className="table table-striped">
          <thead>
            <tr>
              <th className="v-middle" scope="col">
                <div className="form-check">
                  <label className="form-check-label mt-1" htmlFor="taskName">
                    {getLangTranslation("ADD_CHILD_NAME", "Name")}
                  </label>
                </div>
              </th>
              <th className="v-middle" scope="col">
                {getLangTranslation("PHONE_NUMBER", "Phone number")}
              </th>
              <th className="v-middle" scope="col">
                {getLangTranslation("CALL_DURATION", "Call Duration")}
              </th>
              <th className="v-middle" scope="col">
                {getLangTranslation("DATE", "Date")}
              </th>
              <th className="v-middle" scope="col">
                {getLangTranslation(
                  "DEVICE_DETAIL_FIND_DEVICE_STATUS",
                  "Status"
                )}
              </th>
            </tr>
          </thead>
          <tbody>
            {callLogs?.map((item, index) => (
              <tr key={index}>
                <td className="v-middle">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id={`checkbox-${item?.ID}`}
                      checked={selectedItems.includes(item?.ID)}
                      onChange={() => handleCheckboxClick(item?.ID)}
                    />
                    <label
                      className="form-check-label text-nowrap"
                      htmlFor="one"
                    >
                      {item?.callName}
                    </label>
                  </div>
                </td>
                <td className="v-middle text-nowrap">{item?.calledNumber}</td>
                <td className="v-middle text-nowrap">{item?.callDuration}</td>
                <td className="v-middle text-nowrap">
                  {moment(item?.callDate).format("MMM, DD YYYY hh:mm")}
                </td>
                <td className="v-middle text-nowrap">
                  {item?.callType}{" "}
                  {getLangTranslation("CHILD_DASHBOARD_CALL", "Call")}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {callLogs?.length === 0 && (
          <div className="text-center my-2 text-capitalize">
            --{" "}
            {getLangTranslation(
              "PARENT_TASK_DATA_NOT_FOUND",
              "No data found !"
            )}{" "}
            --
          </div>
        )}
      </div>
    </>
  );
};

export default CallLog;
